import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useResInputStore } from '@/features/Sparten/res/useInputStore';

export const hasPartner = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.RES_TARIFGRUPPE,
    SIMPLE_CHOICE_META.RES_TARIFGRUPPE_IS_FAMILY,
  ).includes(useResInputStore().tarifgruppe);
